<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less">
.flex {
  display: flex;
}
.align-items {
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-right-10 {
  margin-right: 10px !important;
}

.margin-top-10 {
  margin-top: 10px;
}

.text-center {
  text-align: center;
}

.display-none {
  display: none;
}

.full-width {
  width: 100% !important;
}

// element-ui
.el-message.zd-el-message {
  padding: 8px 16px;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  border-color: #ffffff;
  min-width: 0;
}

.el-message__content {
  font-size: 14px;
  // color: #515a6e !important;
}

.info-check-content-div {
  .el-form-item__label {
    font-size: 14px;
    color: #8f9bb3 !important;
  }
}

.el-menu {
  background-color: transparent !important;
  border-right: none !important;
}

.el-submenu__icon-arrow {
  color: #8f9bb3 !important;
}

.el-menu-item:hover {
  background-color: transparent !important;
}

.el-submenu__title:hover {
  background-color: transparent !important;
}

.el-submenu.is-opened {
  // background: linear-gradient(241deg, rgba(125, 95, 244, 0.17) 0%, rgba(105, 78, 237, 0.17) 100%)!important;
  // background: rgba(74, 144, 226, 0.8) !important;
}

.el-menu-item.is-active {
  width: 100%;
  height: 54px;
  color: #4182eb !important;
  // background: #E7F0FF;
  border-radius: 10px;
  background: #e7f0ff !important;
  // background-color: transparent !important;
  font-weight: 600;

  .second-menu-title {
    // background: rgba(74, 144, 226, 0.8) !important;
    // border-right: 5px solid #ffffff !important;
  }
}

.el-menu--popup {
  padding: 0 !important;
  border-radius: 6px !important;
  overflow: hidden;
}

.el-menu--popup-right-start {
  .el-menu-item {
    background-color: #ffffff !important;
  }

  .second-menu-title {
    color: #bb87f3;
    font-size: 14px;
  }
}

/** 基本按钮 背景*/
.common-bg-button {
  padding: 0 24px;
  height: 30px;
  background: #4182eb;
  border: 2px solid #4182eb;
  border-radius: 2px;
  outline: 0;
  line-height: 16px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-right: 10px;
  cursor: pointer;
}

/** 基本按钮 - 空心背景*/
.common-empty-button {
  padding: 0 24px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid #4182eb;
  outline: 0;
  line-height: 16px;
  font-size: 12px;
  font-weight: 400;
  color: #4182eb;
  margin-right: 10px;
  cursor: pointer;
}

/** 详情页*/
.detail-container {
  .detail-bread-crumb-div {
    height: 64px;
    display: flex;
    align-items: center;
  }

  .detail-content-div {
    margin: 0 24px 24px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -8px 16px 0px rgba(42, 42, 68, 0.1);
    border-radius: 10px;
    min-height: 800px;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;

    .page-title-div {
      font-size: 20px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
    }
  }

  .detail-content-header-div {
    height: 72px;
    background: rgba(247, 247, 255, 1);
    margin: -24px -32px 0 -32px;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    align-items: center;
    padding: 0 22px;

    .left-page-title-div {
      font-size: 22px;
      font-weight: 500;
      color: #4182eb;
      line-height: 72px;
    }
  }

  .detail-content-body-div {
    padding: 32px 0;
  }

  .detail-content-footer-div {
    height: 72px;
    background: rgba(247, 247, 255, 1);
    margin: 0px -32px -24px -32px;
    border-bottom-left-radius: 30px;
    display: flex;
    border-bottom-right-radius: 30px;
    align-items: center;
    padding: 0 32px;
  }
}

/** 列表页*/
.list-container {
  .list-bread-crumb-div {
    height: 64px;
    display: flex;
    align-items: center;
  }

  .list-content-div {
    margin: 0 24px 24px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -8px 16px 0px rgba(42, 42, 68, 0.1);
    border-radius: 10px;
    min-height: 800px;
    padding: 24px 32px;

    .list-header-title-div {
      height: 72px;
      background: rgba(247, 247, 255, 1);
      margin: -24px -32px 0 -32px;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      align-items: center;
      padding: 0 32px;
      font-size: 22px;
      font-weight: 500;
      color: #4182eb;
      line-height: 72px;
    }

    .page-querys {
      margin-top: 24px;
    }
  }
}
.topTitle {
  background-color: #f7f7ff;
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  div:nth-child(1) {
    font-size: 16px;
    font-weight: 500;
    font-family: PingFangSC, PingFang SC;
  }
  div:nth-child(2) {
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #4182eb;
  }
}
.list-header-title {
  height: 72px;

  margin: -24px -32px 0 -32px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  align-items: center;
  padding: 0 32px;
  font-size: 22px;
  font-weight: 900;

  line-height: 72px;
}
// pile-station detail distpicker 覆盖样式
.distpicker-address-wrapper select {
  padding: 0.3rem 0.75rem !important;
  height: 32px !important;
  font-size: 13px !important;
}

.table-content {
  border-radius: 8px;
  border: 2px solid #eaeaea;

  .page-action-btns {
    height: 65px;
    background: #fafafa;
    align-items: center;
    border-bottom: 2px solid #eaeaea;

    .left-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9b9b9b;
      line-height: 25px;
      padding-left: 30px;
    }

    .right-btn {
      text-align: right;
    }
  }

  .list-table {
    margin: 30px 43px 30px 43px;
  }

  .list-pagination {
    margin-bottom: 30px;
  }
}

//活动列表弹窗样式   作废电站弹窗样式
.el-message-box__wrapper .el-message-box--center {
  width: 567px;

  .el-message-box__title {
    display: flex;
    justify-content: flex-start;
    font-size: 22px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
  }

  .el-message-box__message p {
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #000000;
  }

  .message-content .title {
    font-weight: 500;
    font-size: 18px;
  }

  .message-content.color .title {
    color: red;
  }

  .color {
    color: red !important;
  }

  .message-content .content {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
  }

  .message-content .textHeader {
    font-size: 14px;
    height: 20px;
    margin: 15px auto;
    line-height: 20px;
    color: #4182eb;
  }

  .el-message-box__btns {
    margin-top: 20px;

    .el-button {
      width: 130px;
      height: 40px;
    }

    .el-button--small {
      opacity: 1;
      border: 1px solid #4182eb;
      border-radius: 5px;
      background-color: #4182eb;
      color: #fff;
    }

    .el-button--primary {
      background: #4182eb;
      color: #fff;
    }
  }
}

//图片上传样式

.list-header-content {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 230px;
    height: 230px;
  }

  .list-header-content-title {
    width: 100%;
    padding-left: 80px;
    margin: 20px auto;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #000000;
  }

  .list-header-content-title-form {
    width: 100%;
    margin: 20px auto;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #000000;
  }

  .el-upload--picture-card {
    width: 230px;
    height: 230px;
  }

  .el-upload .el-upload--picture-card {
    width: 100%;
    height: 100%;
  }

  .el-upload-dragger .el-icon-upload {
    margin: 20px auto;
    font-size: 45px;
  }

  .el-upload-dragger {
    width: 230px;
    height: 230px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: flex-start;

    .text {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 10px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #bcbcbc;
    }
  }

  .load {
    //视频样式
    .el-upload--picture-card {
      background: #fff;
      line-height: 0px;
      height: auto;

      .text {
        width: 100%;
        height: 150px;
        line-height: 30px;
        text-align: center;
        font-size: 10px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #bcbcbc;
      }

      .el-icon-upload {
        margin: 20px auto;
        font-size: 45px;
        color: #c0c4cc;
      }

      .el-icon-circle-close {
        font-size: 25px;
        color: #fff;
        background-color: red;
        position: absolute;
        top: -7.5px;
        right: -7.5px;
        border-radius: 50%;
        z-index: 999;
      }

      .videoBox {
        position: relative;
        width: 230px;

        video {
          width: 100%;
          border-radius: 6px;
        }
      }
    }
  }

  .el-checkbox .el-checkbox__input .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  .el-checkbox__input .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    position: absolute;
    top: 1px;
  }
}

.el-dialog {
  min-width: 400px;
}

.activity-table .el-table__header-wrapper {
  display: none;
}

.shop-box .el-table__header-wrapper {
  background-color: red;
}

.herfUrl {
  cursor: pointer;

  .urlText {
    color: #4182eb;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.load {
  .el-upload-list {
    display: none;
  }
}

.hide .el-upload--picture-card {
  display: none;
}

.el-form-item__content {
  .el-input-number {
    width: 100%;

    .el-input__inner {
      max-width: 650px;
      text-align: left;
    }
  }
}

.onNet {
  .el-upload-list {
    display: none;
  }
}
</style>
